<template>
  <span class="pt_badge label label-important js-tooltip" data-title="Piano terapeutico"> PT </span>
</template>
<script>
export default {
  name: 'ptLabel',
};
</script>
